import { CheckOutlined } from '@ant-design/icons';
import { Button, Modal } from 'antd';
import React, { useEffect, useState, useRef } from 'react';

const BaseModal = ({ className, children, footer, title, visible, onHide, onClick, disabled, width, hideText, type, confirmText, loading }) => {
  const [pending, setPending] = useState(false);
  const pendingRef = useRef(false);

  useEffect(() => {
    if (visible) {
      pendingRef.current = false;
      setPending(false);
    }
  }, [visible]);

  useEffect(() => {
    if (pending && !loading) {
      pendingRef.current = false;
      setPending(false);
    }
  }, [pending, loading]);

  const onHideClick = (event) => {
    event.stopPropagation();
    pendingRef.current = false;
    setPending(false);
    onHide();
  };

  const onConfirmClick = (event) => {
    event.stopPropagation();
    if (pendingRef.current || loading) return;
    pendingRef.current = true;
    setPending(true);
    onClick();
  };

  return (
    <Modal
      className={className}
      title={title}
      open={visible}
      width={width}
      footer={footer || [
        <div className="modal-buttons">
          <Button type="text" onClick={onHideClick}>{hideText || 'Annuler'}</Button>
          <Button
            onClick={onConfirmClick}
            type={type || 'primary'}
            disabled={disabled}
            icon={<CheckOutlined />}
            loading={pending || loading}
          >
            {confirmText || 'Confirmer'}
          </Button>
        </div>
      ]}
      centered
      closable={false}
      destroyOnClose
      maskClosable={false}
      keyboard={false}
    >
      {children}
    </Modal>
  );
};

export default BaseModal;